import React from 'react'
import { RouteComponentProps } from 'react-router'

import Button from 'components/Button'
import T from 'components/FormattedMessage'
import SelectFriends from 'components/SelectFriends'
import GameCreationScreen from 'components/GameCreationScreen'

import { FriendsResponse, IUser } from 'protos'
import { Action } from 'types'

import helpIconUrl from 'assets/images/users_icon.svg'

interface Props {
  getUserFriends: () => Promise<FriendsResponse>
  selectedFriendIds: Set<string>
  onFriendSelect: (friend: IUser) => void
  onFriendDeselect: (friend: IUser) => void
  onFriendsSubmit: () => void
}

type State = {
  friends: Action<FriendsResponse | null>
}

type InjectedProps = Props & RouteComponentProps<{}>

class SelectFriendsScreen extends React.Component<InjectedProps, State> {
  constructor(props: InjectedProps) {
    super(props)
    this.state = {
      friends: { isLoading: true },
    }
  }

  componentDidMount() {
    this.props.getUserFriends()
      .then((result: FriendsResponse) => {
        this.setState({ friends: { isLoading: false, result } })
      })
      .catch((err: Error) => {
        this.setState({ friends: { isLoading: false, errorCode: err.message } })
      })
  }

  renderSubmitButton = () => {
    const { selectedFriendIds, onFriendsSubmit } = this.props

    return (
      <Button
        rounded={false}
        fullWidth
        size="large"
        color="primary"
        variant="contained"
        onClick={onFriendsSubmit}
        disabled={selectedFriendIds.size < 1}
      >
        <T id="privategame_action_invite" />
      </Button>
    )
  }

  renderContent = () => {
    const { selectedFriendIds, onFriendSelect, onFriendDeselect } = this.props
    const { friends } = this.state

    if (!friends.result) {
      return null
    }

    return (
      <SelectFriends
        friends={friends.result.friend}
        selectedFriendIds={selectedFriendIds}
        onFriendSelect={onFriendSelect}
        onFriendDeselect={onFriendDeselect}
      />
    )
  }

  render() {
    const { friends } = this.state

    return (
      <GameCreationScreen
        title={<T id="privategame_title" />}
        isLoading={friends.isLoading}
        errorCode={friends.errorCode}
        component={this.renderContent}
        onBack={this.props.history.goBack}
        bottomChild={this.renderSubmitButton()}
        help={{
          iconUrl: helpIconUrl,
          title: 'privategame_help_title',
          message: 'privategame_help_text',
          buttonLabel: 'privategame_help_dismiss',
        }}
      />
    )
  }
}

export default SelectFriendsScreen
